import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { CheckIfAuthenticatedResponse } from "@ServerTypes/accounts/accounts.schema";

export interface CheckIfAuthenticatedState {
  data: CheckIfAuthenticatedResponse;
}

const initialState: CheckIfAuthenticatedState | null = null;

const checkIfAuthenticatedSlice = createSlice({
  name: "checkIfAuthenticated",
  initialState: initialState as CheckIfAuthenticatedState | null,
  reducers: {
    setCheckIfAuthenticated: (
      _state: CheckIfAuthenticatedState | null,
      action: PayloadAction<CheckIfAuthenticatedState | null>,
    ) => action.payload,
  },
});

export const { setCheckIfAuthenticated } = checkIfAuthenticatedSlice.actions;
export default checkIfAuthenticatedSlice.reducer;
